export default "__VITE_ASSET__CZkZlZE4__"